import React from 'react';
// import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import clsx from 'clsx';
// import {
//   Redirect,
// } from 'react-router-dom'
// import Typography from '@material-ui/core/Typography';

import Form  from 'components/UI/Form/Form'
import {
  send as formSubmitAction,
  hasSentFailed as isFormErrored,
  getLog as getFormLog,
  getError as getFormError,
  isSending as isFormRunning,
  isSent as isFormComplete,
} from './ducks/oestroOrder';

import {
  getCurrentUser,
} from 'components/UI/Account/ducks/authentication';



const FIELDS_FULL = [
  {
    id: 'firstname',
    name: 'firstname',
    label: 'Prénom',
    validation: ['notEmpty', 'alphaNum'],
    maxLength: 64,
    sizes: { xs: 12, sm: 6 },
  },
  {
    id: 'name',
    name: 'name',
    label: 'Nom',
    validation: ['notEmpty', 'alphaNum'],
    maxLength: 64,
    sizes: { xs: 12, sm: 6 },
  },
  {
    id: 'address',
    name: 'address',
    label: 'Adresse',
    validation: ['notEmpty', 'alphaNum'],
    maxLength: 128  ,
    sizes: { xs: 12, sm: 12 },
  },
  {
    id: 'city',
    name: 'city',
    label: 'Ville',
    validation: ['notEmpty', 'alphaNum'],
    maxLength: 64,
    sizes: { xs: 12, sm: 6 },
  },
  {
    id: 'zip',
    name: 'zip',
    label: 'Code postal',
    validation: ['notEmpty', 'num', 'alphaNum'],
    maxLength: 5,
    minLength: 5,
    sizes: { xs: 12, sm: 6 },
  },
  // {
  //   id: 'cell',
  //   name: 'cell',
  //   label: 'Téléphone (mobile)',
  //   validation: ['cell'],
  //   sizes: { xs: 12, sm: 6 },
  // },
  {
  id: 'rpps',
  name: 'rpps',
  label: 'RPPS',
  validation: ['notEmpty', 'alphaNum'],
  maxLength: 11,
  sizes: { xs: 12, sm: 6 },
  },
  {
    id: 'email',
    name: 'email',
    label: 'Email',
    validation: ['notEmpty', 'email'],
    maxLength: 64,
    sizes: { xs: 12, sm: 6 },
  },
  {
    id: 'optin',
    name: 'optin',
    type: 'checkbox',
    label: 'J’autorise le laboratoire Theramex à m’envoyer des informations institutionnelles, environnementales ainsi que sur ces produits.',
    fullWidth: true,
    sizes: { xs: 12 },
  },
  {
    id: 'optin2',
    name: 'optin2',
    type: 'checkbox',
    label: 'homeOrderAcceptPolicy',
    fullWidth: true,
    translate: true,
    sizes: { xs: 12 },
  },

]

class ContactForm extends Form {
  constructor(props) {
    super(props);
    this.state = {};
    // let $$FIELDS;
    // console.log('userRole is', props.userRole)
      this.$$FIELDS = Immutable.fromJS(FIELDS_FULL);
  }

  componentDidMount() {
    this._setupState();
    // this._mapRawValues(this.props.$$formValues);
  }
  componentDidUpdate(oldProps) {
  //   // console.log('old', oldProps)
  //   // console.log('new', this.props)
  //   // if (oldProps.$$formValues !== this.props.$$formValues)
  //     // console.log(oldProps.$$formValues.toJS(), this.props.$$formValues.toJS())
  //     console.log(this.props)
    if ((oldProps.isFormComplete === undefined || oldProps.isFormComplete === false) && this.props.isFormComplete === true) {
      if (this.props.onFormComplete) this.props.onFormComplete();
    }
  }
  // _setFormValues: function() {
  //   const { $$formValues } = this.props;
  //
  // }

  // _mapRawValues($$values) {
  //   if ($$values === undefined || !$$values.get || $$values.get('email') === undefined) return;
  //   var o = {
  //   }
  //   // return Immutable.fromJS(o);
  //   // return $$values;
  //   // var tmp = {}
  //   // $$values.map((val, k) => {
  //   Immutable.fromJS(o).map((val, k) => {
  //     this._onFieldValueChange(null, {id: k, value: val});
  //     return true;
  //   })
  //   // return $$values;
  //   return Immutable.fromJS(o);
  //
  // }

  _getI18n() {
    this.i18n = {
      send: 'Commander',
      sending: '...',
      requiredFieldsLegend: 'Champs obligatoires',
    };
  }

  render() {
    const {
      // error,
      // loading,
      className,
      // log,
      // isFormComplete,
      // onFormComplete
      // userRole,
    } = this.props;
    // console.log({isFormComplete})
    //
    // if (isFormComplete) {
    //   const url ='/contact'
    //   return <Redirect to={{
    //       pathname: url,
    //       state: { from: this.props.location }
    //     }}/>
    //   }
// console.log({isFormComplete})
    return (
      <div className={clsx('Form', className)}>
          {this._renderForm()}
      </div>
    );

  }
}

const mapStateToProps = ($$state) => {
  return {
    isFormErrored: isFormErrored($$state),
    log: getFormLog($$state),
    error: getFormError($$state),
    loading: isFormRunning($$state),
    isFormComplete: isFormComplete($$state),
    $$formValues: getCurrentUser($$state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (formData) => {
      dispatch(formSubmitAction(formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/HomeOestro/OrderForm.jsx